import api from '@/api'

export default {
  fetchRules: ({dispatch, commit, state}, {service, taskId}) => {
    api.request(service, 'get', `/tasks/metadata/${taskId}`)
      .then((response) => {
        commit('SET_RULES', response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
